import OpenModals from './OpenModals';

export default OpenModals;
